import React from 'react';

import classNames from 'classnames';

import type { ValidUniversalToothId } from '@videa/utils/src/normalizeToothIds';

import { ToothQuadrant } from './ToothQuadrant';

interface PrimaryOdontogramProps {
  className?: string;
  onToothClick?: (toothId: ValidUniversalToothId) => void;
  selectedTooth: Set<ValidUniversalToothId>;
}

export const PrimaryOdontogram: React.FC<PrimaryOdontogramProps> = ({
  className,
  onToothClick,
  selectedTooth,
}) => {
  return (
    <div
      className={classNames(
        'vai-flex vai-justify-center vai-items-center vai-h-fit',
        className,
      )}
    >
      <div className="vai-grid vai-grid-cols-2 vai-grid-rows-2 vai-gap-0.5 vai-items-center vai-w-fit vai-h-fit vai-content-center">
        <ToothQuadrant
          startNumber="A"
          position="topRight"
          isPrimary
          toothCount={5}
          onToothClick={onToothClick}
          selectedTooth={selectedTooth}
        />
        <ToothQuadrant
          startNumber="F"
          position="topLeft"
          isPrimary
          toothCount={5}
          onToothClick={onToothClick}
          selectedTooth={selectedTooth}
        />
        <ToothQuadrant
          startNumber="T"
          position="bottomLeft"
          isPrimary
          toothCount={5}
          onToothClick={onToothClick}
          selectedTooth={selectedTooth}
        />
        <ToothQuadrant
          startNumber="O"
          position="bottomRight"
          isPrimary
          toothCount={5}
          onToothClick={onToothClick}
          selectedTooth={selectedTooth}
        />
      </div>
    </div>
  );
};
